export const isLocalhost =
  window.location.hostname.includes('localhost') ||
  window.location.hostname.startsWith('127.') ||
  window.location.hostname.startsWith('10.') ||
  window.location.hostname.startsWith('172.') ||
  window.location.hostname.startsWith('192.');
